<div class="content-container" [attr.data-testid]="ELEMENT_IDS['page']">
    <div class="header-container" [attr.data-testid]="ELEMENT_IDS['hdr']">
        <div class="title">
        <h6 i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Warehouse</h6>
        </div>
        <p class="subtitle" i18n [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">
        Please select the warehouse you want to access
        </p>
    </div>
    <form 
        class="form-container"
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()"
        [attr.data-testid]="ELEMENT_IDS['form']"
    >
        <app-custom-select
            controlName="warehouse"
            label="Warehouse"
            [dataSource]="warehouseList"
            valueRef="description"
            [density]="5"
            [elementId]="ELEMENT_IDS['dropdown_warehouse']"
        >
            <ng-template #optionTemplate let-option>
                <span>{{ option.description }}</span>
            </ng-template>
        </app-custom-select>

        <div class="button-container">
            <div class="action-button">
                <app-custom-button
                    [elementId]="ELEMENT_IDS['btn_proceed']"
                    buttonType="primary"
                    text="Proceed"
                    [loading]="loading"
                    [isSubmit]="true"
                >
                </app-custom-button>
            </div>
        </div>
    </form>
</div>
